import { render, staticRenderFns } from "./ListaLotes.vue?vue&type=template&id=2818d9e8&scoped=true"
import script from "./ListaLotes.vue?vue&type=script&lang=js"
export * from "./ListaLotes.vue?vue&type=script&lang=js"
import style0 from "./ListaLotes.vue?vue&type=style&index=0&id=2818d9e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2818d9e8",
  null
  
)

export default component.exports